import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Accordian from "./Accordian";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { useFormik } from "formik";
import { palette } from "../../../../theme/palette";
import { getActiveStep } from "../../../../redux/test/actions";
import {
  chainId,
  getAddNetwork,
  getAllMnemonics,
  getEnvironmentConfig,
} from "../../../../redux/node/actions";
import { MiniConfigValidation } from "../../../../utils/schema";
import Card from "../../../../components/card/Card";
import SteppersUI from "../../../../components/newStepper/NewStepper";
import Account from "./Account";
import PreFunf from "./PreFunf";
import SelectPharse from "./SelectPharse";
import Summry from "./Summry";
const bip39 = require("bip39");
const CryptoJS = require("crypto-js");

const SCREENS = {
  NODE_SETTINGS: 0,
  PRE_FUNDED: 1,
  ACCOUNT_DETAILS: 2,
  PHRASE_VERIFICATION: 3,
  SUMMARY: 4,
};
const styles = {
  cardDivider: {
    background:
      "radial-gradient(50% 50% at 50% 50%, rgba(1, 62, 183, 0.31) 0%, rgba(255, 255, 255, 0) 100%)",
    height: 300,
    width: 4,
  },
  flexBox1: {
    flex: { xs: "0 0 100%", md: "0 0 48%" },
    display: { xs: "flex", md: "block" },
    justifyContent: "center",
    flexDirection: "column",
  },
  mainTypography: {
    textTransform: "none",
    mb: "1.3rem",
    mt: { xs: "1rem", md: "0" },
    lineHeight: { xs: "30px", md: "38px" },
  },
  flexBox2: {
    display: { xs: "none", md: "flex" },
  },
  flexBox3: {
    flex: { xs: "0 0 100%", md: "0 0 48%" },
    width: "100%",
  },
  upperBox: {
    display: "flex",
    justifyContent: "space-between",
    mt: "2.9rem",
  },
  buttonBox: {
    display: "flex",
    justifyContent: "flex-end",
    mt: "1.5rem",
  },
  highlightText: {
    color: "#013eb7",
    fontFamily: "InterSemiBold",
  },
};
const ACCOUNT_TYPES = {
  ADD_ACCOUNT: "addAccount",
  GENERATE_ACCOUNT: "generateAccount",
};

const DEFAULT_ACCOUNT_VALUES = {
  amount: 100000,
  supplyChain: 1000000,
};

const Settings = () => {
  const location = useLocation();
  const state = location.state;
  const [RadioValue, setValue] = useState(state?.type);
  const [algoValue, setAlgoValue] = useState("POS");
  const [inputValue, setInputFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getMnemonic, SetGetMnemonic] = useState("");
  const [hasError, setHasError] = useState(true);
  const [hasAddError, setHasAddError] = useState(true);
  const [screen, setScreen] = useState(0);

  const {
    networkName,
    networkMission,
    networkRegion,
    environmentName,
    deployOption,
    provider, //1
    algorithm,
    envValue, //2
    accountType,
    getNewMnemonics,
    inputFields,
  } = useSelector((state) => state.node);

  const [selectedValue, setSelectedValue] = useState(
    accountType ? accountType : "",
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notify = () =>
    toast.success("Environment is created.", {
      style: {
        padding: "14px",
        color: palette.primary.main,
        animation: "none",
        transition: "none",
      },
      iconTheme: {
        primary: palette.primary.main,
        secondary: "#FFFAEE",
      },
    });

  const handleChangeRadio = (event) => {
    setSelectedValue(event.target.value);
    if (event.target.value === "addAccount") {
      setInputFields([
        // ...inputValue,
        {
          accountName: "",
          mnemonics: "",
          supplyChain: envValue?.inputFields?.[0]?.supplyChain
            ? envValue?.inputFields?.[0]?.supplyChain
            : 1000000,
          amount: envValue?.inputFields?.[0]?.amount
            ? envValue?.inputFields?.[0]?.amount
            : 100000,
        },
      ]);
    } else if (event.target.value === "generateAccount") {
      // if (event.target.value === "generateAccount") {
      if (getNewMnemonics) {
        setInputFields([
          // ...inputValue,
          {
            accountName: "Account-1",
            mnemonics: getNewMnemonics,
            supplyChain: envValue?.inputFields?.[0]?.supplyChain
              ? envValue?.inputFields?.[0]?.supplyChain
              : 1000000,
            amount: envValue?.inputFields?.[0]?.amount
              ? envValue?.inputFields?.[0]?.amount
              : 100000,
          },
        ]);
      } else {
        const GetMnemonics = bip39.generateMnemonic((12 / 12) * 128);
        const nemonics = GetMnemonics && GetMnemonics?.split(" ");
        const duplicateElement =
          nemonics &&
          nemonics?.filter((item, index) => nemonics?.indexOf(item) !== index);

        if (duplicateElement.length > 0) {
          const newMnemonics = bip39.generateMnemonic((12 / 12) * 128);
          dispatch(getAllMnemonics(newMnemonics));
          SetGetMnemonic(newMnemonics);
          setInputFields([
            // ...inputValue,
            {
              accountName: "Account-1",
              mnemonics: newMnemonics,
              supplyChain: envValue?.inputFields?.[0]?.supplyChain
                ? envValue?.inputFields?.[0]?.supplyChain
                : 1000000,
              amount: envValue?.inputFields?.[0]?.amount
                ? envValue?.inputFields?.[0]?.amount
                : 100000,
            },
          ]);
        } else {
          dispatch(getAllMnemonics(GetMnemonics));
          SetGetMnemonic(GetMnemonics);
          setInputFields([
            // ...inputValue,
            {
              accountName: "Account-1",
              mnemonics: GetMnemonics,
              supplyChain: envValue?.inputFields?.[0]?.supplyChain
                ? envValue?.inputFields?.[0]?.supplyChain
                : 1000000,
              amount: envValue?.inputFields?.[0]?.amount
                ? envValue?.inputFields?.[0]?.amount
                : 100000,
            },
          ]);
        }
      }
      // }
    } else {
      return;
    }
  };
  const screenTitles = useMemo(
    () => ({
      [SCREENS.NODE_SETTINGS]: "What is meant by node settings?",
      [SCREENS.PRE_FUNDED]: "Pre-funded accounts",
      [SCREENS.ACCOUNT_DETAILS]:
        selectedValue === ACCOUNT_TYPES.ADD_ACCOUNT
          ? "What is meant by account details?"
          : "What is meant by generate account?",
      [SCREENS.PHRASE_VERIFICATION]: "Phrase verification step",
      [SCREENS.SUMMARY]: "Summary",
    }),
    [selectedValue],
  );

  // Handling the onchange of the textfiels and add to the inputfield state
  const handleInputChange = (index, event) => {
    const updatedFields = [...inputValue];
    updatedFields[index][event.target.name] = event.target.value;
    setInputFields(updatedFields);
  };
  // Remove the add account input fields
  const handleRemoveField = (index) => {
    const updatedFields = [...inputValue];
    updatedFields.splice(index, 1);
    const value = formik.values.inputFields;
    value.splice(index, 1);
    setInputFields(updatedFields);
  };
  // Handling Consensus Algorithm value
  const handleAlgoValue = (event) => {
    setAlgoValue(event.target.value);
  };
  // Handling   Provider value
  const handleChange = (event) => {
    const value = event.currentTarget.getAttribute("data-value");
    setValue(value);
  };
  // Formik initial value
  const initialValues = {
    idvalue: "",
    password: "",
    coinName: "",
    denom: "",
    symbol: "",
    // amount: "",
    // period: "",
    inputFields: [],
  };

  // const handleAddField = () => {
  //   if (selectedValue === "addAccount") {
  //     setInputFields([
  //       ...inputValue,
  //       {
  //         accountName: "",
  //         mnemonics: "",
  //         amount: 100000,
  //         supplyChain: 1000000,
  //       },
  //     ]);
  //   } else {
  //     setInputFields([
  //       ...inputValue,

  //       {
  //         accountName: envValue?.inputFields?.[0]?.accountName,
  //         mnemonics: envValue?.inputFields?.[0]?.mnemonics,
  //         supplyChain: envValue?.inputFields?.[0]?.supplyChain
  //           ? envValue?.inputFields?.[0]?.supplyChain
  //           : 1000000,
  //         amount: envValue?.inputFields?.[0]?.amount
  //           ? envValue?.inputFields?.[0]?.amount
  //           : 100000,
  //       },
  //     ]);
  //   }
  // };

  // Formik handle submit

  const onSubmit = async (values) => {
    const cipherText = CryptoJS.AES.encrypt(
      JSON.stringify(values?.inputFields[0]?.mnemonics),
      process.env.REACT_APP_ENCRYPTION_KEY,
    ).toString();
    const apiData = {
      validator: networkName,
      chainId: values?.idvalue,
      password: values?.password,
      accountName: values?.inputFields[0]?.accountName,
      balance: values?.inputFields[0]?.supplyChain * 1,
      stakeAmount: values?.inputFields[0]?.amount * 1,
      mnemonic: cipherText,
      coinName: "u" + values?.coinName?.toLowerCase(),
      ...state,
    };
    let data = { Provider: RadioValue, Algorithm: algoValue, value: values };
    try {
      if (
        !values?.inputFields[0]?.accountName ||
        values?.inputFields[0]?.accountName.length < 1
      ) {
        setHasAddError(false);
      } else {
        dispatch(getActiveStep(3));
        dispatch(getEnvironmentConfig(data));
        // navigate("/node-overview");
        // notify();
        dispatch(getAddNetwork(apiData, navigate, setLoading));
      }
    } catch (error) {
      // console.log(error, "error in onSubmit");
    }
  };
  const formik = useFormik({
    onSubmit,
    initialValues,
    validationSchema: MiniConfigValidation(state?.type),
  });
  useEffect(() => {
    const fetchData = async () => {
      const data = {
        Provider: RadioValue,
        Algorithm: algoValue,
        value: formik.values,
        accountType: selectedValue,
      };
      dispatch(getEnvironmentConfig(data));
    };

    fetchData(); // Call the function to fetch data when component mounts
  }, [RadioValue, algoValue, formik.values, dispatch]); // Add dependencies if needed

  const handleBackScreen = () => {
    // dispatch(getActiveStep(1));
    // navigate("/network-details");
    if (selectedValue === "addAccount") {
      setScreen(2);
    } else {
      setScreen(3);
    }
  };
  // const{setFieldValue}=formik
  useEffect(() => {
    formik?.setFieldValue("inputFields", inputValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue]);
  useEffect(() => {
    if (formik?.values?.inputFields?.[0]?.mnemonics) {
      const validateMnemonic = bip39?.validateMnemonic(
        formik?.values?.inputFields[0]?.mnemonics,
      );
      setHasError(validateMnemonic === true ? true : false);
    }
  }, [formik.values, hasError]);

  useEffect(() => {
    if (!state?.change) {
      formik.setFieldValue("idvalue", envValue.idvalue);
      formik.setFieldValue("password", envValue.password);
      formik.setFieldValue("symbol", envValue.symbol);
      formik.setFieldValue("denom", envValue.denom);
      formik.setFieldValue("coinName", envValue.coinName);
    }
  }, [envValue.value, selectedValue !== "addAccount", formik.errors]);

  useEffect(() => {
    formik.setFieldValue("inputFields", envValue.inputFields);
    formik.setFieldValue("period", envValue.period);
  }, [envValue.value]);

  useEffect(() => {
    if (accountType) {
      setSelectedValue(accountType);
    }
  }, [accountType]);

  useEffect(() => {
    let data = {
      Provider: RadioValue,
      Algorithm: algoValue,
      value: formik.values,
      accountType: selectedValue,
    };
    dispatch(getEnvironmentConfig(data));
  }, [formik.values]);

  const { stepperSteps } = useSelector((state) => state.test);
  useEffect(() => {
    if (stepperSteps === -1) {
      navigate("/");
    }
  }, [stepperSteps]);

  const renderScreenDescription = () => {
    const HighlightSpan = ({ children }) => (
      <span style={styles.highlightText}>{children}</span>
    );

    switch (screen) {
      case SCREENS.NODE_SETTINGS:
        return (
          <Box>
            <Typography variant="subtitle1" sx={{ textAlign: "left" }}>
              <HighlightSpan>Nodes play</HighlightSpan> a critical role in a
              Blockchain network by maintaining the network's security and
              consensus. To ensure that all nodes agree on the state of the
              Blockchain, they validate transactions, verify data, and
              communicate with other nodes.
            </Typography>
            {/* {state?.type === "zenith" && ( */}
            <Typography variant="subtitle1" textAlign="left" mt={1}>
              A <HighlightSpan>Coin Symbol</HighlightSpan> acts like a currency
              symbol (e.g.,CTA, ETH, BTC). It uniquely identifies your
              blockchain's native token.
            </Typography>
            {/* )} */}
            <Typography variant="subtitle1" textAlign="left" mt={1}>
              A <HighlightSpan>Chain ID</HighlightSpan> is a one-of-a-kind
              identifier for a blockchain network.
            </Typography>
            <Typography variant="subtitle1" textAlign="left" mt={1}>
              The network configuration you are performing is being encrypted
              with this
              <HighlightSpan> password</HighlightSpan>. Therefore, please save
              this password to view these configurations in the future and use
              it to import accounts.
            </Typography>
          </Box>
        );

      case SCREENS.PRE_FUNDED:
        return (
          <Box>
            <Typography variant="subtitle1" textAlign="left">
              An account can be designated as a{" "}
              <HighlightSpan>pre-funded account</HighlightSpan>. When an account
              is designated as pre-funded, the initial supply of network will be
              deposited into this account.
            </Typography>
          </Box>
        );

      case SCREENS.ACCOUNT_DETAILS:
        return (
          <Box>
            {selectedValue === ACCOUNT_TYPES.ADD_ACCOUNT ? (
              <Typography variant="subtitle1" textAlign="left">
                Adding an account requires{" "}
                <HighlightSpan>mnemonics</HighlightSpan>. If you don't have a
                mnemonic, you can go back and generate an account, and please
                remember to save your mnemonic.
              </Typography>
            ) : (
              <>
                <Typography variant="subtitle1" textAlign="left">
                  Users can also change their default{" "}
                  <HighlightSpan>Account name</HighlightSpan>.
                </Typography>
                <Typography variant="subtitle1" textAlign="left" mt={1}>
                  <HighlightSpan>Mnemonic</HighlightSpan> phrases are an
                  optimized version of private keys for easier memorization. You
                  can use a mnemonic or seed phrase to confirm transactions and
                  recover lost cryptocurrency wallet accounts.
                </Typography>
              </>
            )}
            <Typography variant="subtitle1" textAlign="left" mt={1}>
              <HighlightSpan>Chain Supply</HighlightSpan> is the total supply of
              a {formik.values.coinName?.toUpperCase() || "CTA"} coin that
              exists within a network. It should be greater than 1000000.
            </Typography>
            <Typography variant="subtitle1" textAlign="left" mt={1}>
              <HighlightSpan>Initial Stake amount</HighlightSpan> refers to the
              initial quantity or value of a{" "}
              {formik.values.coinName?.toUpperCase() || "CTA"} coin that a
              participant commits and locks up as a stake when participating in
              a consensus mechanism. It should be greater than or equal to {""}
              100000 and less than Chain Supply
            </Typography>
          </Box>
        );

      case SCREENS.PHRASE_VERIFICATION:
        return (
          <Box>
            <Typography variant="subtitle1" sx={{ textAlign: "left" }}>
              Verification step for the generated mnemonic. Please arrange the
              words below in the appropriate order to proceed further.
            </Typography>
          </Box>
        );

      case SCREENS.SUMMARY:
        return (
          <Box>
            <Typography variant="subtitle1" sx={{ textAlign: "left" }}>
              Please check the <HighlightSpan>summary</HighlightSpan> of the
              whole process. If you want to make any changes, you can do so.
              However, once you finish, your network will be created, and you
              will not be able to change it again.
            </Typography>
          </Box>
        );

      default:
        return null;
    }
  };

  const renderScreenContent = () => {
    const screenProps = {
      formik,
      handleRemoveField,
      handleInputChange,
      inputValue,
      hasError,
      hasAddError,
      envValue,
      setScreen,
      selectedValue,
      setSelectedValue,
      handleChange: handleChangeRadio,
    };

    switch (screen) {
      case SCREENS.NODE_SETTINGS:
        return <Accordian {...screenProps} state={state} />;
      case SCREENS.PRE_FUNDED:
        return <PreFunf {...screenProps} state={state} />;
      case SCREENS.ACCOUNT_DETAILS:
        return <Account {...screenProps} />;
      case SCREENS.PHRASE_VERIFICATION:
        return <SelectPharse setScreen={setScreen} />;
      case SCREENS.SUMMARY:
        return <Summry setScreen={setScreen} formik={formik} state={state} />;
      default:
        return null;
    }
  };

  return (
    <Card>
      <Box
        sx={{
          mt: { xs: "1.8rem", md: ".5rem" },
          display: "flex",
          width: "100%",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Box sx={{ maxWidth: "600px", width: "100%" }}>
          <SteppersUI />
        </Box>
      </Box>

      <Box
        display="flex"
        sx={{
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          mt: 4,
        }}
      >
        {/* First flex box contain title and text */}
        <Box sx={styles.flexBox1}>
          <Typography variant="h1" sx={styles.mainTypography}>
            {screenTitles[screen] || ""}
          </Typography>
          {renderScreenDescription()}
        </Box>

        {/* Second flex box contain the divider line */}
        <Box sx={styles.flexBox2}>
          <Box sx={styles.cardDivider} />
        </Box>

        <Box sx={styles.flexBox3}>
          {/* Formik form */}
          <form
            onSubmit={formik.handleSubmit}
            style={{ width: "100%", height: "auto" }}
          >
            {renderScreenContent()}

            {screen === SCREENS.SUMMARY && (
              <Box sx={styles.buttonBox}>
                <Button
                  onClick={handleBackScreen}
                  data-cy="Back4"
                  sx={{
                    borderRadius: "5px",
                    maxWidth: "7.2rem",
                    width: "100%",
                  }}
                  variant="text"
                  disabled={loading}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  data-cy="Finish"
                  disabled={!hasError || loading}
                  sx={{
                    borderRadius: "5px",
                    maxWidth: "7.2rem",
                    width: "100%",
                    ml: ".5rem",
                  }}
                  variant="contained"
                >
                  {loading ? <CircularProgress size="1.7rem" /> : "Finish"}
                </Button>
              </Box>
            )}
          </form>
        </Box>
      </Box>
    </Card>
  );
};

export default Settings;
